interface ErrorResponse {
    code: number;
    message: string;
}

export interface JackpotCreateState {
    jackpotCreateData: any;
    loading: boolean;
    jackpotCreatError: ErrorResponse | null;
}


export enum JackpotCreateActionTypes {
    FETCH_JACKPOT_CREATE_DATA = "FETCH_JACKPOT_CREATE_DATA",
    FETCH_JACKPOT_CREATE_DATA_SUCCESS = "FETCH_JACKPOT_CREATE_DATA_SUCCESS",
    FETCH_JACKPOT_CREATE_DATA_ERROR = "FETCH_JACKPOT_CREATE_DATA_ERROR",
}

export type JackpotCreateAction =
    | { type: JackpotCreateActionTypes.FETCH_JACKPOT_CREATE_DATA }
    | { type: JackpotCreateActionTypes.FETCH_JACKPOT_CREATE_DATA_SUCCESS; payload: any[] }
    | { type: JackpotCreateActionTypes.FETCH_JACKPOT_CREATE_DATA_ERROR; payload: any };